import {
  dispatchProjectSearchSidebarFilter,
  sidebarFilterForTag,
  sidebarFilterForUser
} from '../../../components/ProjectSearchBar/sidebarFilterBridge';
import { User } from './types';

export const applyLeftNavUserFilter = (
  user: Pick<User, 'id' | 'role' | 'email'>,
  canAssignGuests = false
) => {
  dispatchProjectSearchSidebarFilter(
    sidebarFilterForUser(user, canAssignGuests)
  );
};

export const applyLeftNavTagFilter = (tag: {
  id: number | string;
  name: string;
}) => {
  dispatchProjectSearchSidebarFilter(sidebarFilterForTag(tag));
};
